var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.94 43.2606C26.58 43.2606 23.24 41.6006 20.6 33.6606L19.16 29.3406L14.84 27.9006C6.92001 25.2606 5.26001 21.9206 5.26001 19.5606C5.26001 17.2206 6.92001 13.8606 14.84 11.2006L31.82 5.54063C36.06 4.12063 39.6 4.54063 41.78 6.70063C43.96 8.86063 44.38 12.4206 42.96 16.6606L37.3 33.6406C34.64 41.6006 31.3 43.2606 28.94 43.2606ZM15.78 14.0606C10.22 15.9206 8.24001 18.1206 8.24001 19.5606C8.24001 21.0006 10.22 23.2006 15.78 25.0406L20.82 26.7206C21.26 26.8606 21.62 27.2206 21.76 27.6606L23.44 32.7006C25.28 38.2606 27.5 40.2406 28.94 40.2406C30.38 40.2406 32.58 38.2606 34.44 32.7006L40.1 15.7206C41.12 12.6406 40.94 10.1206 39.64 8.82063C38.34 7.52063 35.82 7.36063 32.76 8.38063L15.78 14.0606Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.72 28.8C20.34 28.8 19.96 28.66 19.66 28.36C19.08 27.78 19.08 26.82 19.66 26.24L26.82 19.06C27.4 18.48 28.36 18.48 28.94 19.06C29.52 19.64 29.52 20.6 28.94 21.18L21.78 28.36C21.5 28.66 21.1 28.8 20.72 28.8Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendTwo);
export default __webpack_public_path__ + "static/media/SendTwo.87bac796.svg";
export { ForwardRef as ReactComponent };